import { ViewChild, Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'common-document-warning-modal',
    templateUrl: 'common-document-warning-modal.component.html',
    styles: []
})

export class CommonDocumentWarningComponent implements OnInit {

    @Input() modalDetails: any;
    @ViewChild('commonDocumentUploadWarningModal', { static: true })
    @Output() outputEmit = new EventEmitter<any>();
    commonDocumentUploadWarningModal: any;

    constructor() { }

    ngOnInit() { }

    modalInterVal: any
    ngOnChanges() {
        if (this.modalDetails && this.modalDetails.sprigNotAvailable) {
            this.commonDocumentUploadWarningModal.show();
            this.modalInterVal = setInterval(() => {
                this.checkSprigAvailable();
            }, 700);
        }
    }

    isLoading: boolean = false;
    checkSprigAvailable() {
        const getLocalSprig = localStorage.getItem('selectedDevice')
        const getSelectedSprig = getLocalSprig ? JSON.parse(getLocalSprig) : null;

        if (getSelectedSprig && getSelectedSprig.basePathUrl && getSelectedSprig.installationId) {
            this.commonDocumentUploadWarningModal.hide();
            clearInterval(this.modalInterVal)
        }

    }

    checkSprig() {
        this.isLoading = true;
        this.outputEmit.emit(true);
        setTimeout(() => {
            this.isLoading = false;
        }, 1000);
    }

}